import { serviceApi } from '../service-api'
import { InitialData } from './InitialData'

export class InitialDataLoader {
  static async load(): Promise<InitialData> {
    const response = await serviceApi.get<InitialData>('/api/initializing/initialload')
    Object.setPrototypeOf(response.data, InitialData.prototype)
    return response.data
  }
}
